import throttle from "lodash/throttle";

function checkScrollState() {
  if (window.scrollY > 0) {
    document.body.classList.add("scrolled");
  } else {
    document.body.classList.remove("scrolled");
  }
}

export default function initScrollStateClass() {
  document.addEventListener("scroll", throttle(checkScrollState, 150), true);
  checkScrollState();
}
